﻿import DOMPurify from 'dompurify';

const sanitize = (content: string) =>
    DOMPurify.sanitize(content, {
        RETURN_DOM_FRAGMENT: false,
        RETURN_DOM: false,
        USE_PROFILES: {
            html: true,
            svg: true,
            svgFilters: true,
        },
        ADD_TAGS: ['use'],
    });

export default sanitize;
